import moment from 'moment';
import fields from "./fields.utils";


const schema_generic = {
    ...fields.notes,
    //source
    "source_uuid": {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    "postcode": {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: "text",
        value: '',
        required: true,

    },
    "first_name": {
        label: "First Name",
        placeholder: "First Name",
        type: "text",
        value: '',
        required: true,

    },
    "last_name": {
        label: "Last Name",
        placeholder: "Last Name",
        type: "text",
        value: '',
        required: true,

    },
    "date_of_birth": {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,

        placeholder: 'Date of Birth'
    },
    "telephone": {
        label: "Telephone",
        placeholder: "Telephone",
        type: "text",
        value: '',
        required: true,

    },
    "email": {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',
    },
    "has_criminal_convictions": {
        label: "criminal convictions",
        value: false,
        type: 'bool',
        required: true,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    "has_driving_convictions": {
        label: "driving convictions",
        value: false,
        type: 'bool',
        required: true,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    "has_claims": {
        label: "Claims",
        value: false,
        type: 'bool',
        required: true,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    "number_of_drivers": {
        label: "number of drivers",
        type: 'number',
        value: 0,

        required: true,
        placeholder: 'number of drivers'
    },
    "number_of_vehicles": {
        label: "number of vehicles",
        type: 'number',
        value: 0,

        required: true,
        placeholder: 'number of vehicles'
    },
    "personal_miles": {
        label: "personal miles",
        type: 'number',
        value: 0,

        required: true,
        placeholder: 'personal miles'
    },
    "business_miles": {
        label: "business miles",
        type: 'number',
        value: 0,

        required: true,
        placeholder: 'business miles'
    },
    "cover_date": {
        label: 'Cover Date',
        type: 'date-picker',
        value: moment().format("DD/MM/YYYY"),
        required: true,

        placeholder: 'Cover Date'
    },
    ...fields.marketing,
    ...fields.title,
    ...fields.cross_selling
};
export default schema_generic;
